/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { generateDays, generateMinFareRequestSeo } from '@/components/RoutePage/SectionManager/utils';
import WrapperSection from '@/components/RoutePage/SectionManager/WrapperSection';
import { TSelectedDate } from '@/slices/calendar';
// slices
import {
  TMinFareObj, TMinFareRequest,
  useLazyGetFlightByIdQuery, useLazyGetFlightDataQuery, useLazyGetFlightStatisticsQuery, useLazyGetFlightStatisticsSeoRoute2Query, useLazyGetFlightStatisticsSeoRouteQuery,
} from '@/slices/flightData/apis/flightDataApi';
import { resetSelectedContact } from '@/slices/passenger/slices/passengerSlice';
import { addFlight } from '@/slices/selectedFlight/slices/selectedFlightSlice';
import { mappingCompanySlugToCode } from '@/utils/airlineMapping';
// utils
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { pr } from '@/utils/pxToRem';
import { Stack, Box } from '@mui/material';
import { format } from 'date-fns';
import {
  get, isEmpty, minBy, uniq,
} from 'lodash';
import moment from 'moment';
import { useRouter } from 'next/router';
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { CONTENT_SECTION, FAQ, metaFaqJson } from '../constants';
import AccordionComponent from '@/components/RoutePage/AccordionComponent';
import {
  IGroupedByFlightNameSeoRoute, ItemSeoRoute,
} from './type';
import { monthYears } from '@/utils/monthYears';
import { matchPriceOrDash } from '@/utils/matchPriceOrDash';
import { TGenerateFlightCountRequest } from '@/utils/generateFlightRequest';
import { tetDays } from '@/utils/constants';
import { groupItemByDate } from '@/components/CompanyPageVcms/utils';

const formatDate = (date: Date) => format(date, 'yyyy-MM-dd');

export const getMappingDatePriceDataCalendar = (dataTetStatics: { [key: string]: any }) => {
  const dayPriceObjStatictis = {} as TMinFareObj;
  if (!dataTetStatics?.grouped_by_date) return dayPriceObjStatictis;
  Object.keys(dataTetStatics?.grouped_by_date).forEach((groupedDate) => {
    dayPriceObjStatictis[groupedDate] = dataTetStatics?.grouped_by_date?.[groupedDate]?.final_min_fare;
  });
  return dayPriceObjStatictis;
};

export const getMappingDatePriceData = (dataStatisticsTetSeo: any, tetPage?: boolean) => {
  let daysInNewYears = tetPage ? tetDays.filter((day) => ((day.monthVN === 12 && day.dayVN >= 26) || (day.monthVN === 1 && day.dayVN <= 4))) : tetDays.filter((day) => (day.monthVN === 12 && (day.dayVN >= 25 && day.dayVN <= 30)));
  daysInNewYears = JSON.parse(JSON.stringify(daysInNewYears));
  const dataGroup = dataStatisticsTetSeo ? groupItemByDate(dataStatisticsTetSeo as any) : null;
  if (dataGroup) {
    daysInNewYears.forEach((item: any) => {
      const key = item.dateStr;
      const matchDate = dataGroup[key] ? minBy(dataGroup[key], 'total_price_adult') : 0;
      item.minFare = matchPriceOrDash(!matchDate ? 0 : Math.round((matchDate.total_price_adult) / 1000));
      item.time = matchDate ? matchDate.pickup_time : '';
      item.averageMinfare = matchDate ? matchDate.total_price_adult : '';
      item.airline = matchDate ? matchDate.airline : {};
      item.id = matchDate?.id;
      item.pickup_time = matchDate?.pickup_time;
      item.dropoff_time = matchDate?.dropoff_time;
    });
  }

  return daysInNewYears;
};

export const getMappingDatePriceDataByAirlineLuna = (dataStatisticsTetSeo: any) => {
  const dataGroup = dataStatisticsTetSeo ? groupItemByDate(dataStatisticsTetSeo as any) : null;
  if (dataGroup) {
    return dataGroup?.['2024-12-31'] || null;
  }
  return null;
};

export const getMappingDatePriceDataByAirline = (dataStatisticsTetSeo: any, dateStr?: string) => {
  const dataGroup = dataStatisticsTetSeo ? groupItemByDate(dataStatisticsTetSeo as any) : null;
  if (dataGroup && dateStr) {
    return dataGroup[dateStr] || null;
  }

  return null;
};

interface ISectionManager {
  sxWrapper?: {
    [key: string]: any
  },
  hasBorder?: boolean | undefined,
  data: any,
  idComponent: string | undefined,
  title: string | undefined,
  content?: {
    [key: string]: any
  },
  routeName: string,
  routeName2: string,
  company: string,
  companySlug: string,
  startPointHome: any,
  toPointHome: any,
  routeCode: string,
  routeCodeReturn: string,
  onSearchFlight: (date: TSelectedDate) => void,
  countResult: any,
  countSeoTetResult: any,
  countSeoResult: any,
  countSeoAllResult: any,
  countTetResult?: any,
  countSeoReturnResult: any,
  isDesktop?: boolean;
}

function SectionManager(props: Partial<ISectionManager>) {
  const {
    sxWrapper, idComponent, routeName, routeName2, toPointHome, routeCode, onSearchFlight, routeCodeReturn, startPointHome, company, companySlug,
    countResult, countSeoResult, countSeoAllResult, countSeoReturnResult, isDesktop, countTetResult, countSeoTetResult,
  } = props;
  const router = useRouter();
  const [getFlightDepartById, { data: flightById }] = useLazyGetFlightByIdQuery();

  const startPointState = useAppSelector((state) => state.searchFlightForm.startPointHome);
  const toPointState = useAppSelector((state) => state.searchFlightForm.toPointHome);
  const startPoint = startPointState || startPointHome;
  const toPoint = toPointState || toPointHome;
  const dispatch = useAppDispatch();
  const [
    getFlightStatisticsSeoRoute,
    {
      isFetching: isFetchingStatisticsSeo,
      currentData: dataStatisticsSeoResult,
      error: errorStatisticsSeo,
    },
  ] = useLazyGetFlightStatisticsSeoRouteQuery();

  const [
    getAllFlightStatisticsSeoRoute,
    {
      currentData: dataAllFlightStatisticsSeoResult,
    },
  ] = useLazyGetFlightStatisticsSeoRouteQuery();

  const [
    getFlightStatisticsSeoRoute2,
    {
      currentData: dataStatisticsSeoReturnResult,
    },
  ] = useLazyGetFlightStatisticsSeoRoute2Query();

  const [getMinFare, { data: dataStatisticsResult, isLoading }] = useLazyGetFlightStatisticsQuery();

  const getRoute = (result: any) => (isEmpty(result) ? null : result);
  const dataStatisticsSeo = getRoute(dataStatisticsSeoResult) || countSeoResult;
  const dataAllFlightStatisticsSeo = getRoute(dataAllFlightStatisticsSeoResult) || countSeoAllResult;
  const dataStatisticsSeoReturn = getRoute(dataStatisticsSeoReturnResult) || countSeoReturnResult;
  const dataStatistics = getRoute(dataStatisticsResult) || countResult;
  const dataTetStatics = countTetResult;
  const dataStatisticsTetSeo = countSeoTetResult;

  const [
    getFlightData,
  ] = useLazyGetFlightDataQuery();

  const { passenger } = useAppSelector((state) => state.searchFlightForm);
  const [selectedDate, setSelectedDateState] = useState(moment().toISOString());

  const fromAirports = startPoint?.airports?.map((airport: any) => airport.airportCode) || [];
  const toAirports = toPoint?.airports?.map((airport: any) => airport.airportCode) || [];

  const days = generateDays({
    date: selectedDate,
    minDate: moment().toISOString(),
    maxDate: moment().add(30, 'days').toISOString(),
  });
  const allAirlineDays = generateDays({
    date: selectedDate,
    minDate: moment().toISOString(),
    maxDate: moment().add(30, 'days').toISOString(),
  });

  const dataGroup = dataStatisticsSeo ? groupItemByDate(dataStatisticsSeo as any) : null;
  const allAirlineDataGroup = dataAllFlightStatisticsSeo ? groupItemByDate(dataAllFlightStatisticsSeo as any) : null;
  const groupedByLlightNameSeoRoute: IGroupedByFlightNameSeoRoute | undefined = dataStatisticsSeo?.grouped_by_flight_name_seo_route;
  let dataObj = groupedByLlightNameSeoRoute && routeCode ? groupedByLlightNameSeoRoute[routeCode] : {} as ItemSeoRoute;

  const groupedByLlightNameSeoRoute2: IGroupedByFlightNameSeoRoute | undefined = dataStatisticsSeoReturn?.grouped_by_flight_name_seo_route;
  const dataObjReturn = groupedByLlightNameSeoRoute2 && routeCodeReturn ? groupedByLlightNameSeoRoute2[routeCodeReturn] : {} as ItemSeoRoute;
  dataObj = {
    ...dataObj,
    lowest_round_flight_price: (dataObj?.lowest_price || 0) + (get(dataObjReturn, 'lowest_price') || 0),
  };
  const daysInNewYears = getMappingDatePriceData(dataStatisticsTetSeo);
  const findDayNewYear = tetDays.find((day) => (day.monthVN === 1 && day.dayVN === 1));

  useEffect(() => {
    if (!startPoint || !toPoint) {
      return;
    }
    const flightRequestObject = generateMinFareRequestSeo({
      fromDateStr: flightRequest.fromDate,
      toDateStr: flightRequest.toDate,
      startPoint,
      toPoint,
      passenger,
      // airline: mappingCompanySlugToCode(companySlug || ''),
    });
    const allFlightRequestObject = generateMinFareRequestSeo({
      fromDateStr: flightRequest.fromDate,
      toDateStr: flightRequest.toDate,
      startPoint,
      toPoint,
      passenger,
    });
    const flightRequestObjectReturn = generateMinFareRequestSeo({
      fromDateStr: flightRequest.fromDate,
      toDateStr: flightRequest.toDate,
      startPoint: toPoint,
      toPoint: startPoint,
      passenger,
      // airline: mappingCompanySlugToCode(companySlug || ''),
    });

    getMinFare(flightRequestStatistics);
    getFlightStatisticsSeoRoute(flightRequestObject);
    getFlightStatisticsSeoRoute2(flightRequestObjectReturn);
    getAllFlightStatisticsSeoRoute(allFlightRequestObject);
  }, [startPoint, toPoint]);

  useEffect(() => {
    if (daysInNewYears?.length) {
      daysInNewYears.forEach((element) => {
        getFlightData({
          from: fromAirports,
          to: toAirports,
          flight_class: 'PT',
          date: element?.dateStr || format(new Date(selectedDate), 'yyyy-MM-dd'),
        });
      });
    }
  }, [daysInNewYears?.length]);

  const handleSelectDate = (date: Date) => {
    setSelectedDateState(date.toISOString());
  };

  const flightRequest: TMinFareRequest = {
    from: fromAirports,
    to: toAirports,
    fromDate: days ? formatDate(days[0].date) : formatDate(new Date()),
    toDate: days ? formatDate(days[days.length - 1].date) : formatDate(new Date()),
    mode: 'flight',
  };

  const flightRequestStatistics: TGenerateFlightCountRequest = {
    from: fromAirports,
    to: toAirports,
    month_years: monthYears(),
    quantity: 1,
    flight_class: 'PT',
    // airline: [mappingCompanySlugToCode(companySlug || '')],
    // disable_update_filter: 1,
  };

  useEffect(() => {
    if (flightById) {
      const from = startPoint?.airports[0]?.nameVn;
      const to = toPoint?.airports[0]?.nameVn;
      dispatch(addFlight(flightById));
      const stringParams = {
        from,
        to,
        date: {
          depart: flightById?.route?.departureDate ? flightById?.route?.departureDate : selectedDate,
        },
        passenger: {
          adt: 1,
          chd: 0,
          inf: 0,
        },
        seatClass: 'PT',
      };
      router.push(`/trip-detail?${qs.stringify(stringParams)}&flightId[depart]=${flightById?.idIndex}`);
    }
  }, [flightById]);

  const dayPriceObj: any = {};
  if (dataGroup) {
    days.forEach((item: any) => {
      const key = item.dateStr;
      const matchDate = dataGroup[key] ? minBy(dataGroup[key], 'total_price_adult') : 0;
      item.minFare = matchPriceOrDash(!matchDate ? 0 : Math.round((matchDate.total_price_adult) / 1000));
      item.time = matchDate ? matchDate.pickup_time : '';
      item.averageMinfare = matchDate ? matchDate.total_price_adult : '';
      item.airline = matchDate ? matchDate.airline : {};
      item.id = matchDate?.id;
      item.pickup_time = matchDate?.pickup_time;
      item.dropoff_time = matchDate?.dropoff_time;
      dayPriceObj[key] = matchDate ? matchDate.total_price_adult : '';
    });
  }
  if (allAirlineDataGroup) {
    allAirlineDays.forEach((item: any) => {
      const key = item.dateStr;
      const matchDate = allAirlineDataGroup[key] ? minBy(allAirlineDataGroup[key], 'total_price_adult') : 0;
      item.minFare = matchPriceOrDash(!matchDate ? 0 : Math.round((matchDate.total_price_adult) / 1000));
      item.time = matchDate ? matchDate.pickup_time : '';
      item.averageMinfare = matchDate ? matchDate.total_price_adult : '';
      item.airline = matchDate ? matchDate.airline : {};
      item.id = matchDate?.id;
      item.pickup_time = matchDate?.pickup_time;
      item.dropoff_time = matchDate?.dropoff_time;
    });
  }

  const dayPriceObjStatictis = {} as TMinFareObj;
  dataStatistics?.forEach((group: any) => {
    Object.keys(group?.grouped_by_date).forEach((groupedDate) => {
      dayPriceObjStatictis[groupedDate] = group?.grouped_by_date[groupedDate].min_fare;
    });
  });

  if (!startPoint || !toPoint) return null;

  const handleSelectTrip = (item: any) => {
    if (item?.id) {
      getFlightDepartById({ id: item?.id });
    }
    dispatch(resetSelectedContact());
  };

  const airlinesInNewYears = uniq((daysInNewYears.filter((item) => !!item?.airline?.name).map((item) => item?.airline?.name) || []));
  const airlinesAll = uniq((days.filter((item) => !!item?.airline?.name).map((item) => item?.airline?.name) || []));
  const renderComponent = ({ section }: any) => {
    const Component = section.component;
    if (!Component) {
      return null;
    }
    return (
      <Component
        isLoading={isLoading}
        isDesktop={isDesktop}
        days={days}
        allAirlineDays={allAirlineDays}
        isCompanyCityCity={companySlug !== ''}
        company={companySlug}
        startPoint={startPointHome}
        toPoint={toPointHome}
        daysInNewYears={daysInNewYears}
        selectedDate={selectedDate}
        handleSelectDate={handleSelectDate}
        isFetching={isFetchingStatisticsSeo}
        errorStatistics={errorStatisticsSeo}
        flightData={dataGroup}
        allAirlineFlightData={allAirlineDataGroup}
        handleSelectTrip={handleSelectTrip}
        routeName={`${startPoint?.location} - ${toPoint?.location}`}
        dayPriceObj={dayPriceObj}
        dayPriceObjStatictis={dayPriceObjStatictis}
        dayTetPriceObjs={getMappingDatePriceDataCalendar(dataTetStatics)}
        dataObj={dataObj}
        onSearchFlight={onSearchFlight}
        airlines={section.isNewYear ? airlinesInNewYears : airlinesAll}
        findDayNewYear={findDayNewYear}
      />
    );
  };
  return (
    <Stack
      sx={{
        ...sxWrapper,
        ...container,

        background: 'white',
      }}
      spacing={pr`24px`}
      id={idComponent}
    >
      {Object.values(CONTENT_SECTION({ isDesktop })).map((section, index) => {
        const { length } = Object.values(CONTENT_SECTION({ isDesktop }));
        if (index === length - 1) {
          return (
            <>

              <AccordionComponent
                isDesktop
                idComponent="faq"
                data={FAQ}
                metaJson={metaFaqJson || ''}
                titleComponent={`Các câu hỏi thường gặp về tuyến đường ${routeName}`}
                dataObj={dataObj}
                minPriceTime={dataGroup?.[format(new Date(), 'yyyy-MM-dd')]?.[0].pickup_time || ''}
                airlines={airlinesAll}
                toPointHome={toPointHome}
                startPointHome={startPointHome}
                routeName={routeName || ''}
                company={company}
              />
              <WrapperSection
                isDesktop
                key={1}
                section={section}
                dataObj={dataObj}
                titleComponent={section.title.component}
                idComponent={section.id}
                airlines={airlinesAll}
                toPointHome={toPointHome}
                startPointHome={startPointHome}
                routeName={routeName}
                routeName2={routeName2 || ''}
                company={company}
                isHaveDivider={(section as any).isHaveDivider!}
              >
                <Box
                  sx={{
                    padding: (section as any).alignCenter && isDesktop ? {
                      xs: '16px 24px',
                      md: '16px 24px',
                      lg: '16px 144px',
                    } : {},
                  }}
                >
                  {renderComponent({ section })}
                </Box>
              </WrapperSection>
            </>

          );
        }
        return (
          <WrapperSection
            isDesktop
            key={2}
            section={section}
            dataObj={dataObj}
            titleComponent={section.title.component}
            idComponent={section.id}
            airlines={airlinesAll}
            toPointHome={toPointHome}
            startPointHome={startPointHome}
            routeName={routeName}
            routeName2={routeName2 || ''}
            company={company}
            isHaveDivider={(section as any).isHaveDivider!}
          >
            <Box
              sx={{
                padding: (section as any).alignCenter && isDesktop ? {
                  xs: '16px 24px',
                  md: '16px 24px',
                  lg: '16px 144px',
                } : {},
              }}
            >
              {renderComponent({ section })}
            </Box>
          </WrapperSection>
        );
      })}

    </Stack>
  );
}
const container = {
};

export default React.memo(SectionManager);
